import axios from "axios";

// Enable CSRF protection and credentials
axios.defaults.withCredentials = true;

let baseURL = "http://localhost:8000";

if (process.env.NODE_ENV === 'production') {
  baseURL = 'https://back.opgi-boumerdes.dz';
} 

export const api = axios.create({
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    baseURL: baseURL,
  });

// Add CSRF token interceptor - more robust version
api.interceptors.request.use((config) => {
  const csrfToken = getCsrfToken();
  if (csrfToken) {
    // Always set both header variants
    config.headers['X-CSRF-TOKEN'] = csrfToken;
    config.headers['X-CSRF-Token'] = csrfToken;
    
    // For FormData, also try to add as a field if it's a POST request
    if (config.data instanceof FormData && (config.method === 'post' || config.method === 'POST')) {
      // Don't add to FormData - keep it in headers only for multipart
    }
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// Helper function to get CSRF token from cookie
function getCsrfToken() {
  const name = 'XSRF-TOKEN';
  
  if (!document.cookie || document.cookie === '') {
    console.warn('[CSRF] No cookies found');
    return null;
  }
  
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    const eqIndex = cookie.indexOf('=');
    
    if (eqIndex > -1) {
      const cookieName = cookie.substring(0, eqIndex);
      if (cookieName === name) {
        const token = decodeURIComponent(cookie.substring(eqIndex + 1));
        console.log('[CSRF] Token found and extracted');
        return token;
      }
    }
  }
  
  console.warn('[CSRF] XSRF-TOKEN cookie not found in cookies:', document.cookie);
  return null;
}

export const BASE_URL = baseURL;